// --latest 12/05--
import * as React from "react";
import { SPHttpClient, SPHttpClientResponse } from "@microsoft/sp-http";
import ContextService from "../../services/ContextService";
import axios from 'axios';
interface IpropsGetAllDisplayFieldName{
    setNewDisplayFields?: React.Dispatch<React.SetStateAction<{}>>
    Refresh?:boolean;
}

let GlobalDataTemp=[]
// let GlobalData={}
// let Data=false


const fetcherFields = async (refresh: boolean): Promise<any[]> => {
  const token = localStorage.getItem("CurrentToken");
  // Use cached data if available and refresh is not requested
  if (GlobalDataTemp.length && !refresh) {
    return GlobalDataTemp;
  }

  try {
    const SiteURL = localStorage.getItem("SiteURL");
    // Axios API call with token authentication
    const response = await axios.get(
      `${SiteURL}/_api/web/lists/getbytitle('CLM365Request')/Fields`,
      {
        headers: {
          Accept: "application/json;odata=nometadata",
          "odata-version": "",
          Authorization: `Bearer ${token}`, // Include token in the request headers
        },
        params: {
          $select: "*",
          $filter: "ReadOnlyField eq false",
        },
      }
    );

    // Process and cache the fetched fields
    const fields = response.data?.value || [];
    GlobalDataTemp = fields; // Cache the data
    return fields; // Return the fetched fields
  } catch (error) {
    console.error("Error fetching fields:", error);
    throw error; // Re-throw error for calling function to handle
  }
};

export  function GetAllDisplayFieldName({
    setNewDisplayFields=(_val)=>{},
    Refresh=false
}:IpropsGetAllDisplayFieldName)
{
return fetcherFields(Refresh).then(c=>{
   const  GlobalData={};
  //  console.log(c,"cccc")
            if (c.length > 0) {
               
                c?.map((templ: any) => {
                   
                   // if (!['Title', 'Contract_Start_Date', 'Guid_ID', 'Counterparty_Name', 'Attachments', 'Status', 'Business_Unit', 'MetaInfo', 'PropertyBag', 'FileLeafRef', 'Order', 'Contract_End_Date', 'Contract_Term', "Contract_Type", "ContentType", "Draft_Type", "Contract_Date", "Priority", "Request_Number", "Request_Type", "File_Name", "Approval_Infos", "Activity_Log", "AllTaskApprovers", "Legal_User", "Remarks", "ActualFileName", "Contract", "RequestApproval", "DraftApproval", "ExecutionApproval", "Negotiation", "ApprovalStage","SOW_Details"].includes(templ.InternalName)) {
                        //console.log(templ.Title,"templ.Title",templ.InternalName);
                        GlobalData[templ.InternalName]=(templ.Title).replaceAll('_', ' ').replace('010Att',"");
                   // }
                })
            }
            ////console.log(GlobalData,"GlobalData");
            setNewDisplayFields({...GlobalData});
                return GlobalData
})
}
